import ModalShare from './ModalShare'

export default ModalShare
